import { File, FileCode2, FileText, Image, Table2 } from "lucide-react";
import { cn } from "@/lib/utils";

type Props = {
  mimeType: string | null;
  className?: string;
};

export function FileIconHelper({ mimeType, className }: Props) {
  const base = cn("size-4 shrink-0 text-muted-foreground", className);

  if (!mimeType) return <File className={base} />;

  if (mimeType.startsWith("image/")) {
    return <Image className={base} />;
  }

  if (
    mimeType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
    mimeType === "application/vnd.ms-excel" ||
    mimeType === "text/csv" ||
    mimeType === "application/csv" ||
    mimeType === "text/tsv"
  ) {
    return <Table2 className={base} />;
  }

  if (
    mimeType === "text/plain" ||
    mimeType === "text/markdown" ||
    mimeType === "application/json"
  ) {
    return <FileCode2 className={base} />;
  }

  return <FileText className={base} />;
}
